import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuService } from '../../services/menu.service';
import { RouterService } from '../../services/router.service';
//import { Location } from '@angular/common';

declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  color: string;
  cols: number;
  rows: number;
  class: string;
  backColor: string;
}

export const ROUTES: RouteInfo[] = [];

@Component({
  selector: 'menu02-data',
  templateUrl: './menu02.component.html',
  animations: [
    trigger('hamburgerX', [
      state('closed', style({ transform: 'rotate(0deg)' })),
      state('open', style({ transform: 'rotate(90deg)' })),
      transition('closed <=> open', animate('200ms ease-in-out'))
    ])
  ]
})


export class Menu02Component {

  constructor(
    private router: Router,
    private menuService: MenuService,
    private securityParams: ActivatedRoute,
    private routerService: RouterService,
    //private location: Location

  ) { }

  menuItems: any[];
  functions: RouteInfo[];
  mainFunction: string;
  title: string;


  async ngOnInit() {
    this.mainFunction = (this.securityParams.snapshot.params.functioncode).toString().toUpperCase();
    this.LoadContent();
  }

  LoadContent()
  {
    this.functions =[];
    this.menuItems = [];
    this.menuService.getFunctionName(this.mainFunction).subscribe(results => {
      if (results.body.isValid) {
        this.title = results.body.resultData.description
      }
      else {
        this.title =results.body.error.description;
      }
    });
    this.menuService.getOptionsLevel2(0,this.mainFunction).subscribe(results => {
      for (const entry of results.body.resultData) {
        this.addRoutes({
          path: '/' + entry.link.trim().toLowerCase(), title: entry.description.trim(),
          icon: entry.icon, color: '#A51955', cols: 1, rows: 1, class: entry.function_class, backColor: entry.backColor 
        });
      }
      this.menuItems = this.functions.filter(menuItem => menuItem);
    },
      (e) => {
        console.log(e);
      });
    this.menuItems = this.functions.filter(menuItem => menuItem);
  }

  addRoutes(route) {
    this.functions.push(route);
  }

  b_back() {
    var _Route=this.routerService.getBackRoute();
      this.router.navigate([_Route], { skipLocationChange: true });
    //this.location.back();

  }

  clickMenu(Route, Id) {
    this.routerService.putRoute("menu02/" + this.mainFunction.toLowerCase())
    this.router.navigate([Route], { skipLocationChange: true }) ;
  }
}






